import React from "react";
import { findYearlyAmountFun } from "../../actions/paymentGateway";

const OrderSummaryBoxComp = ({ selectPlans }) => {
   const plan = `${selectPlans?.interval} Subscription`;
   const price = selectPlans?.amount || 0;

   const isYearlyPlan = selectPlans?.interval === "Yearly";
   const yearlyAmount = findYearlyAmountFun(price);
   const monthlyAmount = yearlyAmount / 12;
   return (
      <div className="pg-order-summary-box">
         <div className="pg-order-summary-text">Order summary</div>
         <div className="pg-subscription-plan-text">{plan}</div>
         <div className="pg-subscription-prise-text">
            {price} {isYearlyPlan && <span className="pg-subprise-text">{`($${monthlyAmount}/month)`}</span>}
         </div>
      </div>
   );
};

export default OrderSummaryBoxComp;
